import { defaultStore, STORES, CONTURS } from './config';

export const getContur = () => {
  switch (defaultStore) {
    case STORES.ae:
    case STORES.qa:
    case STORES.sa:
      return CONTURS.me;
    default:
      return CONTURS.cis;
  }
};
